import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df9d77ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-filter" }, null, -1))
const _hoisted_3 = { class: "container content banner__content" }
const _hoisted_4 = { class: "banner__content-title" }
const _hoisted_5 = { class: "banner__content-btns" }
const _hoisted_6 = { class: "banner__content-inputs" }
const _hoisted_7 = { class: "banner__content-inputs-setting" }
const _hoisted_8 = { class: "banner__content-showBtns" }
const _hoisted_9 = { class: "items-in-line gap--5" }
const _hoisted_10 = {
  key: 0,
  class: "items-in-line gap--5"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Найдено", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " объекта ", -1))
const _hoisted_15 = {
  key: 1,
  class: "items-in-line gap--5"
}
const _hoisted_16 = { class: "banner__content-showMobileBtns" }
const _hoisted_17 = {
  key: 0,
  class: "items-in-line gap--5"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Найдено", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " объекта ", -1))
const _hoisted_22 = {
  key: 1,
  class: "items-in-line gap--5"
}

import { computed, ref } from 'vue';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import InputGroup from '@/components/MainPageComponents/Banner/InputGroup/InputGroup.vue';
import { useAppStore } from '@/store/modules/app';
import { useRouter } from 'vue-router';
import { FilterBlock, FilterBtns } from '@/components/MainPageComponents';


export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  setup(__props) {

const regionGenitive = computed((): string | undefined => {
  return useAppStore().getGenitive();
});

const activeFilterBtn = computed(() => {
  return useOfferCardsStore().activeFilterBtn;
});
const filterBtnsKey = computed(() => {
  return useOfferCardsStore().filterBtnsKey;
});

const objectCount = computed(() => {
  return useOfferCardsStore().objectCount;
});
const isLoading = computed(() => {
  return useOfferCardsStore().isLoadingResultBlock;
});
const isShowMapBlock = computed(() => {
  return useOfferCardsStore().isShowMapBlock;
});
const isShowResultBlock = computed(() => {
  return useOfferCardsStore().isShowResultBlock;
});

const activeRentalBtn = ref(0);
const filterBtnsByRental = [
  {
    id: 'rental1',
    text: 'Посуточно',
  },
  {
    id: 'rental2',
    text: 'Долгострочно',
  },
];

const router = useRouter();
const showMapBlock = async () => {
  if (useAppStore().getWindowWidth() <= 600) {
    await router.push({ name: 'fullMap' });
    await useOfferCardsStore().toggleIsShowResultBlock(false);
  }
  useOfferCardsStore().showResultBlock(true);
};

return (_ctx: any,_cache: any) => {
  const _component_base_button_group = _resolveComponent("base-button-group")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, "Загородная недвижимость " + _toDisplayString(regionGenitive.value), 1),
      _createVNode(_component_base_form, { class: "banner__content-actions" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_unref(FilterBtns), { key: filterBtnsKey.value })),
            (activeFilterBtn.value?.text === 'Снять')
              ? (_openBlock(), _createBlock(_component_base_button_group, {
                  key: 0,
                  active: activeRentalBtn.value,
                  buttons: filterBtnsByRental,
                  btnHeight: "34",
                  btnWidth: "122",
                  class: "banner__content-btns-right",
                  type: "translucentGreen",
                  onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (activeRentalBtn.value = $event))
                }, null, 8, ["active"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(InputGroup, { height: "44" }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_button, {
                height: "44",
                icon: "",
                "style-type": "white",
                width: "44",
                "without-active": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useOfferCardsStore)().toggleShowFilterModal(true)))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_base_icon, {
                    color: "#614B40FF",
                    "font-size": "30",
                    name: "tune"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_base_button, {
              height: "44",
              padding: "15",
              "style-type": "white",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showMapBlock()))
            }, {
              text: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/banner/icon-for-map.svg'),
                    contain: "",
                    height: "25",
                    name: "map",
                    width: "25"
                  }, null, 8, ["src"]),
                  _createTextVNode(" На карте ")
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_base_button, {
              height: "44",
              padding: "15",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(useOfferCardsStore)().showResultBlock()))
            }, {
              text: _withCtx(() => [
                (objectCount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_base_spinner)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(objectCount.value), 1)),
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_base_icon, {
                        color: "#ffffff",
                        name: "search"
                      }),
                      _createTextVNode(" Найти ")
                    ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_base_button, {
              height: "44",
              icon: "",
              "style-type": "white",
              width: "44",
              withoutActive: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(useOfferCardsStore)().toggleShowFilterModal(true)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  color: "#614B40FF",
                  "font-size": "30",
                  name: "tune"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_base_button, {
              height: "44",
              icon: "",
              "style-type": "white",
              width: "44",
              "without-active": "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showMapBlock()))
            }, {
              text: _withCtx(() => [
                _createVNode(_component_base_image, {
                  src: require('@/assets/img/banner/icon-for-map.svg'),
                  contain: "",
                  height: "25",
                  name: "map",
                  width: "25"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_base_button, {
              height: "44",
              padding: "15",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(useOfferCardsStore)().showResultBlock()))
            }, {
              text: _withCtx(() => [
                (objectCount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _createVNode(_component_base_spinner)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(objectCount.value), 1)),
                      _hoisted_21
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_base_icon, {
                        color: "#ffffff",
                        name: "search"
                      }),
                      _createTextVNode(" Найти ")
                    ]))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_unref(FilterBlock), {
      key: filterBtnsKey.value,
      isFilterByTerritory: activeFilterBtn.value?.id === 3,
      "show-coordinates": isShowMapBlock.value,
      "show-list-block": isShowResultBlock.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_unref(useOfferCardsStore)().toggleShowFilterModal(false))),
      onShowResultBlock: _cache[8] || (_cache[8] = ($event: any) => (_unref(useOfferCardsStore)().toggleIsShowResultBlock(true)))
    }, null, 8, ["isFilterByTerritory", "show-coordinates", "show-list-block"]))
  ]))
}
}

})